import {
	Button,
	HStack,
	Separator,
	Stack,
} from '@chakra-ui/react';
import { Form, Link } from '@packages/chakra-v3';

import { APP_ROUTES } from '@/routes';
import type { LoginFormType } from '../../schemas/auth.schema';

type LoginFormProps = {
	onClickLoginWithGoogle: () => void;
};

const LoginForm = ({ onClickLoginWithGoogle }: LoginFormProps) => {
	return (
		<Stack gap={8}>
			<Form.TextInput<LoginFormType>
				isRequired
				label={'Email'}
				name={'email'}
			/>
			<Form.PasswordInput<LoginFormType>
				isRequired
				label={'Password'}
				name={'password'}
			/>
			<HStack justifyContent={'space-between'}>
				<Link href={APP_ROUTES.AUTH.FORGOT_PASSWORD}>Forgot Password?</Link>
				<Link href={APP_ROUTES.AUTH.REGISTER}>Sign up</Link>
			</HStack>
			<Form.SubmitButton>Login</Form.SubmitButton>
			<Separator />
			<Button colorScheme={'blue'} onClick={onClickLoginWithGoogle}>
				Login with Google
			</Button>
		</Stack>

	);
};

export default LoginForm;